import type { GetStaticProps } from "next"
import { PageMeta } from "@/components/resources/components/Seo/PageMeta"
import { getFeedTeasers } from "@/components/resources/data/feed"
import type { Teaser } from "@/components/resources/data/posts.types"
import { SiteLayout } from "@/components/resources/layouts/site"
import { CategoryArchive } from "@/components/resources/templates/CategoryArchive"

interface Props {
  entries: Teaser[]
}

const title = "Data-driven\n research on crypto"
const lead = "Market & project research, video interviews and our weekly newsletter"
const Resources = ({ entries }: Props) => {
  return (
    <>
      <PageMeta
        meta={{
          title: `${title.replace(/\n/, "")}`,
          description: lead,
        }}
      />
      <CategoryArchive entries={entries} title={title} lead={lead} />
    </>
  )
}

Resources.getLayout = SiteLayout

export default Resources

export const getStaticProps: GetStaticProps<Props> = async () => {
  return {
    props: {
      entries: await getFeedTeasers(),
    },
    revalidate: 180,
  }
}
